import React from "react";
import { Helmet } from "react-helmet";

const Head: React.FC = ({ children }) => {
  return (
    <>
      {!!children ? (
        <Helmet>
          <title>Nossa Casa - {children}</title>
          <meta property="og:title" content={`Nossa Casa - ${children}`} />
        </Helmet>
      ) : (
        <Helmet>
          <title>Pepsico - Nossa Casa</title>
          <meta property="og:title" content="Pepsico - Nossa Casa" />
        </Helmet>
      )}
    </>
  );
};

export default Head;